<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageSelfCheckIn.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageSelfCheckIn.card.general')" cols="12 6@desktop" rows="1">
        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.enabled')"
                           :enabled-title="`${$t('enabled')} 🔒`"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           :disabled="config.enabled && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') && hotelSettings.details.google"
                           cols="12 6@hd start-1"
                           name="enabled" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageSelfCheckIn.card.editing')" cols="12 6@desktop" rows="2">
        <!-- allowGuestProfileEditing -->
        <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowGuestProfileEditing')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowGuestProfileEditingEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowGuestProfileEditingDisabled')"
                         v-model="config.allowGuestProfileEditing"
                         :disabled="!hasRole('ROLE_ADMIN')"
                         cols="12 6@hd start-1"
                         name="allowGuestProfileEditing" />
        <!-- allowCompanyProfileEditing -->
        <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowCompanyProfileEditing')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowCompanyProfileEditingEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowCompanyProfileEditingDisabled')"
                         v-model="config.allowCompanyProfileEditing"
                         :disabled="!hasRole('ROLE_ADMIN')"
                         cols="12 6@hd start-1"
                         name="allowCompanyProfileEditing" />
        <!-- allowBillingProfileEditing -->
        <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowBillingProfileEditing')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowBillingProfileEditingEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowBillingProfileEditingDisabled')"
                         v-model="config.allowBillingProfileEditing"
                         :disabled="!hasRole('ROLE_ADMIN')"
                         cols="12 6@hd start-1"
                         name="allowBillingProfileEditing" />
      </card>
      <card :title="`${$t('admin.interfaces.pageSelfCheckIn.card.config')} 🔒`" cols="12 6@desktop" rows="3">
        <hm-card-inner :title="$t('admin.interfaces.pageSelfCheckIn.card.limitations')">
          <!-- allowPaymentCollectUndefined -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowPaymentCollectUndefined')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowPaymentCollectUndefinedEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowPaymentCollectUndefinedDisabled')"
                           v-model="config.allowPaymentCollectUndefined"
                           :disabled="!hasRole('ROLE_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowPaymentCollectUndefined" />
          <!-- allowPaymentTypeUndefined -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowPaymentTypeUndefined')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowPaymentTypeUndefinedEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowPaymentTypeUndefinedDisabled')"
                           v-model="config.allowPaymentTypeUndefined"
                           :disabled="!hasRole('ROLE_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowPaymentTypeUndefined" />
          <!-- allowMultiRoomReservationsSelfCheckIn -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowMultiRoomReservationsSelfCheckIn')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowMultiRoomReservationsSelfCheckInEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowMultiRoomReservationsSelfCheckInDisabled')"
                           v-model="config.allowMultiRoomReservationsSelfCheckIn"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowMultiRoomReservationsSelfCheckIn" />
          <!-- allowCollectiveInvoiceSelfCheckIn -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowCollectiveInvoiceSelfCheckIn')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowCollectiveInvoiceSelfCheckInEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowCollectiveInvoiceSelfCheckInDisabled')"
                           v-model="config.allowCollectiveInvoiceSelfCheckIn"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowCollectiveInvoiceSelfCheckIn" />
          <!-- allowOpenDepositBalance -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositBalance')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositBalanceEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositBalanceDisabled')"
                           v-model="config.allowOpenDepositBalance"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowOpenDepositBalance" />
          <!-- allowOpenDepositPaymentRequest -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositPaymentRequest')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositPaymentRequestEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowOpenDepositPaymentRequestDisabled')"
                           v-model="config.allowOpenDepositPaymentRequest"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowOpenDepositPaymentRequest" />
          <!-- allowDisplayKeys -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowDisplayKeys')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowDisplayKeysEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowDisplayKeysDisabled')"
                           v-model="config.allowDisplayKeys"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowDisplayKeys" />
          <!-- allowRemoteUnlock -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.allowRemoteUnlock')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.allowRemoteUnlockEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.allowRemoteUnlockDisabled')"
                           v-model="config.allowRemoteUnlock"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="allowRemoteUnlock" />
          <!-- requireManualReview -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.requireManualReview')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.requireManualReviewEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.requireManualReviewDisabled')"
                           v-model="config.requireManualReview"
                           :disabled="!hasRole('ROLE_ADMIN')"
                           cols="12 6@hd start-1"
                           name="requireManualReview" />
          <!-- useAiAssistance -->
          <hm-input-toggle v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || config.useAiAssistance"
                           :label="$t('admin.interfaces.pageSelfCheckIn.useAiAssistance')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.useAiAssistanceEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.useAiAssistanceDisabled')"
                           v-model="config.useAiAssistance"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="useAiAssistance" />
          <!-- autoAddOtaPayments -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.autoAddOtaPayments')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.autoAddOtaPaymentsEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.autoAddOtaPaymentsDisabled')"
                           v-model="config.autoAddOtaPayments"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="autoAddOtaPayments" />
          <!-- defaultPaymentMethod -->
          <hm-input-select v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           v-model="config.defaultPaymentMethod"
                           :label="$t('admin.interfaces.pageSelfCheckIn.defaultPaymentMethod')"
                           name="defaultPaymentMethod"
                           cols="12 6@hd start-1">
            <option :value="{ first: 'NotApplicable', second: 'Other' }">{{ $t('admin.interfaces.pageSelfCheckIn.defaultPaymentMethodDefaultOption') }} ({{ $t('PaymentSource.NotApplicable') }} / {{ $t('PaymentMethod.Other') }}</option>
            <template v-if="!isNil(paymentMethodOptions)">
              <option v-for="paymentMethodOption in paymentMethodOptions" :value="paymentMethodOption" :key="`${paymentMethodOption.first}-${paymentMethodOption.second}`">{{ $t(`PaymentSource.${paymentMethodOption.first}`) }} / {{ $t(`PaymentMethod.${paymentMethodOption.second}`) }}</option>
            </template>
          </hm-input-select>
          <!-- excludedChannels -->
          <hm-multiselect v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') && !isEmpty(sourceNameOptions)"
                          v-model="config.excludedChannels"
                          :label="$t('admin.interfaces.pageSelfCheckIn.excludedChannels')"
                          :help="$t('admin.interfaces.pageSelfCheckIn.excludedChannels_help')"
                          :options="sourceNameOptions"
                          name="excludedChannels"
                          cols="12 6@hd start-1" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageSelfCheckIn.card.checkInRequirements')" cols="12 6@desktop" rows="1">
        <!-- requireMeldeblatt -->
        <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.requireMeldeblatt')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.requireMeldeblattEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.requireMeldeblattDisabled')"
                         v-model="config.requireMeldeblatt"
                         :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                         cols="12 6@hd start-1"
                         name="requireMeldeblatt" />
        <!-- requireEmailAddress -->
        <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.requireEmailAddress')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.requireEmailAddressEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.requireEmailAddressDisabled')"
                         v-model="config.requireEmailAddress"
                         :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                         cols="12 6@hd start-1"
                         name="requireEmailAddress" />
        <!-- debug -->
        <hm-input-toggle v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || config.debug"
                         :label="$t('admin.interfaces.pageSelfCheckIn.debug')"
                         :enabled-title="$t('admin.interfaces.pageSelfCheckIn.debugEnabled')"
                         :disabled-title="$t('admin.interfaces.pageSelfCheckIn.debugDisabled')"
                         v-model="config.debug"
                         :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                         cols="12 6@hd start-1"
                         name="debug" />
      </card>
      <card :title="$t('admin.interfaces.pageSelfCheckIn.card.paymentConfig')" cols="12 6@desktop" rows="1">
        <hm-card-inner>
          <!-- requirePaymentAtCheckIn -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.requirePaymentAtCheckIn')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.requirePaymentAtCheckInEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.requirePaymentAtCheckInDisabled')"
                           v-model="config.requirePaymentAtCheckIn"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="requirePaymentAtCheckIn" />
          <!-- requirePaymentForOpenGuestProfileBalance -->
          <hm-input-toggle :label="$t('admin.interfaces.pageSelfCheckIn.requirePaymentForOpenGuestProfileBalance')"
                           :enabled-title="$t('admin.interfaces.pageSelfCheckIn.requirePaymentForOpenGuestProfileBalanceEnabled')"
                           :disabled-title="$t('admin.interfaces.pageSelfCheckIn.requirePaymentForOpenGuestProfileBalanceDisabled')"
                           v-model="config.requirePaymentForOpenGuestProfileBalance"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           cols="12 6@hd start-1"
                           name="requirePaymentForOpenGuestProfileBalance" />
          <!-- authorizationAmount -->
          <hm-input-money v-model="config.authorizationAmount"
                          :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :currency="hotelSettings.details.currency"
                          :required="true"
                          :label="$t('admin.interfaces.pageSelfCheckIn.authorizationAmount')"
                          :help="$t('admin.interfaces.pageSelfCheckIn.authorizationAmount_help')"
                          cols="12 6@hd start-1"
                          name="authorizationAmount" />
        </hm-card-inner>
      </card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import TabableCard from '../../../lib/layout/TabableCard';
import TabableCardContent from '../../../lib/layout/TabableCardContent';
import { TimelineMax, TweenMax } from 'gsap';
import { isProduction } from '@/lib/util/isProduction';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import HmButton from '../../../lib/buttons/HmButton.vue';
import HmCol from '../../../lib/layout/HmCol.vue';
import AutoAddNewRowsMixin from '../../../../mixins/AutoAddNewRowsMixin';
import uuid from 'uuid';
import DynamicTableEditor from '../../../lib/inputgroups/DynamicTableEditor.vue';
import HmInputToggle from '../../../lib/inputs/HmInputToggle.vue';
import PaymentMethods from '@/lib/paymentMethodUtils';
import HmMultiselect from '../../../lib/inputs/HmMultiselect.vue';

export default {
  name: 'PageSelfCheckIn',
  components: { HmMultiselect, HmInputToggle, DynamicTableEditor, HmCol, HmButton, HmInputSelect, TabableCardContent, TabableCard, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, AutoAddNewRowsMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      // event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const storeConfig = cloneDeep(this.config);

        this.axios.put(this.serviceUrls.interfaces.selfCheckIn.get(this, this.interfaceId), storeConfig)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      interfaceId: this.$route.params.interfaceId,
      templates: [],
      genericEmailTemplates: [],
      sourceNames: [],
      paymentMethods: PaymentMethods,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    paymentMethodOptions: function () {
      if (isEmpty(this.paymentMethods)) return [];
      return Object.entries(this.paymentMethods)
        .flatMap(it => Object.entries(it[1])
          .filter(itSource => itSource[1])
          .map(itSource => ({
            first: itSource[0],
            second: it[0],
          })));
    },
    sourceNameOptions: function () {
      if (isEmpty(this.sourceNames)) return [];
      return this.sourceNames.map(it => ({
        id: it,
        name: it,
      }));
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.selfCheckIn.get(this, null))
        .then((response) => {
          this.config = {
            ...response.data.data,
          };
        });
      this.updateTemplates();
      this.loadSourceNames();
    },
    loadSourceNames() {
      this.axios.get(this.serviceUrls.reservation.sourceName(this))
        .then((response) => {
          this.sourceNames = response.data.data;
        });
    },
    updateTemplates() {
      this.axios.get(this.serviceUrls.templateHelper.filter(this, 'Email'))
        .then((response) => {
          this.templates = response.data.data.filter(it => it.type === 'ReservationConfirmationEmail');
          this.genericEmailTemplates = response.data.data.filter(it => it.type === 'GenericEmail');
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageSelfCheckIn.vue